import { InboxOutlined, CloseOutlined } from "@ant-design/icons";
import { Image, Upload, message } from "antd";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { v4 } from "uuid";
import S3 from "react-aws-s3";
import uploadImageToS3 from "../../utils/uploadToS3";

const { Dragger } = Upload;
const props = {
  name: "file",
  multiple: true,
};

const FileUpload = ({ onChange, value, maxCount, ...restProp }) => {
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    setFileList(value || []);
  }, [value]);
  // console.log("fileList12", fileList);
  return (
    <>
      <Dragger
        {...props}
        {...restProp}
        accept={"image/*, application/*,text/*"}
        customRequest={async ({ file, onSuccess, onError }) => {
          const acceptType = ["image/png", "image/jpg", "image/jpeg"];
          if (acceptType.includes(file.type)) {
            const configSettings = {
              bucketName: "ghoshak-image",
              dirName: "expenses-management",
            };

            uploadImageToS3({
              originalFiles: [file],
              bucketName: configSettings.bucketName,
              folderName: configSettings.dirName,
            })
              .then((res) => {
                console.log("res", res);
                onSuccess(
                  {
                    location: res[0],
                  },
                  file
                );
              })
              .catch((err) => {
                onError();
              });
          } else {
            message.error("You can able to upload Images only");
          }
        }}
        onChange={(info) => {
          const { status } = info.file;
          if (status !== "uploading") {
            console.log(info.file, info.fileList);
          }
          if (status === "done") {
            message.success(`${info.file.name} file uploaded successfully.`);
            const obj = {
              id: info.file.uid,
              url: info.file.response.location,
              name: info.file.name,
            };
            onChange(
              Array.isArray(fileList)
                ? maxCount
                  ? [obj, ...fileList].slice(0, maxCount)
                  : [obj, ...fileList]
                : [obj]
            );
          } else if (status === "error") {
            message.error(`${info.file.name} file upload failed.`);
          }
        }}
        showUploadList={false}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Drag and Drop or Browse</p>
      </Dragger>

      {fileList?.map?.((item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "1rem 0",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "12px",
                background: "#FAFAFA",
              }}
            >
              <div>
                <Image
                  src={item.url}
                  alt="invoice bill"
                  style={{
                    width: "30px",
                    height: "38px",
                    objectFit: "cover",
                  }}
                />
                <span style={{ marginLeft: "1rem" }}>{item.name}</span>
              </div>
              <div>
                <CloseOutlined
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setFileList((prev) => {
                      return prev.filter((i) => i.id !== item.id);
                    });
                    const filterId = fileList.filter((i) => i.id !== item.id);
                    onChange(filterId);
                  }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
export default FileUpload;
